/**
 * Standalone page — embed: /learn-more/csv
 */
import React from "react";
import {
    LearnMoreShell,
    WhatIsForaConnectorSection,
    ForaSignupSection,
    LearnMoreFooter,
} from "./shared";

export default function LearnMoreCsv() {
    return (
        <LearnMoreShell
            title="CSV & Fora Connector"
            subtitle={
                <>
                    Import and export <strong>comma-separated (CSV)</strong> files between the{" "}
                    <strong>Fora Mobile Commerce Platform</strong> and your spreadsheets or other systems—no QuickBooks
                    connection required for this path.
                </>
            }
        >
            <div className="space-y-6 text-gray-700">
                <WhatIsForaConnectorSection />
                <section className="rounded-lg border border-gray-100 border-l-4 border-l-slate-500 bg-white shadow-sm p-6 sm:p-8">
                    <p className="text-xs font-bold uppercase tracking-wide text-slate-600 mb-1">Platform</p>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">Overview</h2>
                    <p className="leading-relaxed mb-4">
                        Use the <strong>CSV</strong> platform when you want to work with files instead of QuickBooks
                        Online or QuickBooks Desktop. You can import or export data between Fora and CSV files for
                        customers, products, orders, and related workflows.
                    </p>
                    <ul className="list-disc pl-5 space-y-2 leading-relaxed">
                        <li>
                            <strong>Sample files:</strong> Provide or download sample CSVs with column headers that match
                            how you want customers, products, or orders represented.
                        </li>
                        <li>
                            <strong>Mapping:</strong> Map CSV columns to Fora fields so imports and exports stay
                            consistent.
                        </li>
                        <li>
                            <strong>Import / export jobs:</strong> Run CSV-specific jobs to bring data into Fora or
                            export orders and related data to CSV.
                        </li>
                        <li>
                            <strong>Export field selection:</strong> Choose which fields to include when exporting orders
                            to CSV.
                        </li>
                        <li>
                            <strong>Logs:</strong> Review CSV job results in the connector logs.
                        </li>
                    </ul>
                    <p className="text-sm text-gray-600 leading-relaxed mt-4">
                        CSV is ideal for custom ERP extracts, manual batches, or partners that exchange files instead of
                        using QuickBooks APIs.
                    </p>
                </section>

                <ForaSignupSection />
                <LearnMoreFooter />
            </div>
        </LearnMoreShell>
    );
}
